import httpClient from './httpClient';
import * as apis from '../constants/api';

// user info
export const getUserInfo = () => httpClient.get(apis.GET_USER_INFO);
export const getTutorInfo = () => httpClient.get(apis.GET_TUTOR_INFO);
export const getUser = () => httpClient.get(apis.GET_USER);
export const logout = () => httpClient.post(apis.LOGOUT);
export const saveVendorId = (payload) =>
  httpClient.post(apis.SAVE_VENDOR_ID, { ...payload }, { ignore: true });
export const eventTracker = (payload) =>
  httpClient.post(apis.EVENT_TRACKER, { ...payload }, { ignore: true });
export const getVisitorId = () => httpClient.get(apis.GET_VISITOR_ID);
export const getNeedIdCheck = ({ courseId }) =>
  httpClient.get(`${apis.NEED_ID_CHECK}${courseId}`, {
    ignoreLoading: true,
    ignore: true,
  });
export const mallSmsRegisterV2 = (payload) => httpClient.get(apis.mallSmsRegisterV2(payload));


// importantMessage
export const getImportantMessage = () => httpClient.get(apis.GET_IMPORTANT_MESSAGE);
export const readImportantMessage = (payload) =>
  httpClient.post(apis.READ_IMPORTANT_MESSAGE, { ...payload }, { ignore: true });
export const actionImportantMessage = (payload) =>
  httpClient.post(apis.ACTION_IMPORTANT_MESSAGE, { ...payload }, { ignore: true });

// save vendor
// export const trackingVendor = (payload) =>
//   httpClient.post(apis.TRACKING_VENDOR_RECORD, { ...payload }, { ignore: true });

// player
export const onVideoLastProgress = (payload) =>
  httpClient.post(apis.POST_LAST_PROGRESS, { ...payload }, { ignore: true });
export const onVideoStarted = (payload) =>
  httpClient.post(apis.VIDEO_START, { ...payload }, { ignore: true });
export const onVideoPaused = (payload) =>
  httpClient.post(apis.VIDEO_PAUSE, { ...payload }, { ignore: true });
export const onVideoStopped = (payload) =>
  httpClient.post(apis.VIDEO_STOP, { ...payload }, { ignore: true });
export const onVideoChangeSpeed = (payload) =>
  httpClient.post(apis.VIDEO_CHANGE_SPEED, { ...payload }, { ignore: true });
export const onBulletStarted = (payload) =>
  httpClient.post(apis.BULLET_START, { ...payload }, { ignore: true });
export const onBulletFinished = (payload) =>
  httpClient.post(apis.BULLET_FINISH, { ...payload }, { ignore: true });
export const onGetVideoToken = ({ courseId, bookId, bulletId, videoId, vid }) =>
  httpClient.get(`${apis.GET_VIDEO_TOKEN}/${courseId}/${bookId}/${bulletId}/${videoId}/${vid}`, {
    ignore: true,
  });
export const onGetPublicKey = () =>
  httpClient.get(`${apis.GET_PUBLIC_KEY}`, {
    ignore: true,
  });
export const onMarqueeQuickCheck = (payload) =>
  httpClient.post(apis.MARQUEE_QUICK_CHECK, { ...payload }, { ignore: true });

export const updateBulletNote = (payload) =>
  httpClient.post(apis.UPDATE_BULLET_NOTE, { ...payload }, { ignore: true });
export const fetchBulletNote = (bulletId) =>
  httpClient.get(`${apis.FETCH_BULLET_NOTE}/${bulletId}`, { ignore: true });
export const updateQuestionNote = (payload) =>
  httpClient.post(apis.UPDATE_QUESTION_NOTE, { ...payload }, { ignore: true });
export const fetchQuestionNote = (bulletId) =>
  httpClient.get(`${apis.FETCH_QUESTION_NOTE}/${bulletId}`, { ignore: true });
export const getQuestionReferral = ({ questionId }) =>
  httpClient.get(`${apis.GET_QUESTION_REFERRAL_LIST}/${questionId}`, { ignore: true });
export const getQACpaInfo = () => httpClient.get(apis.GET_QA_CPA_INFO, null, { ignore: true });
export const saveQuestionQA = (payload) =>
  httpClient.post(`${apis.POST_QUESTION_QA}`, { ...payload }, { ignore: true });
export const saveAutoRemove = (payload) =>
  httpClient.post(`${apis.POST_AUTO_REMOVE}`, { ...payload }, { ignore: true });
export const updateProfile = (payload) =>
  httpClient.post(`${apis.POST_UPDATE_PROFILE}`, { ...payload }, { ignore: true });
export const sleep = (ms) => {
  /// eslint-disable-next-line compat/compat
  return new Promise(function (resolve) {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};
export const markQuestion = (payload) =>
  httpClient.post(apis.POST_QUESTION_COLLECT, { ...payload }, { ignore: true });
export const getQuestion = (courseId, questionId) =>
  httpClient.get(`${apis.GET_FIRST_QUESTION}/${courseId}/${questionId}`);
export const answer = (payload) =>
  httpClient.post(apis.POST_QUESTION_ANSWER, { ...payload }, { ignore: true });
export const questionReport = (payload) =>
  httpClient.post(apis.POST_QUESTION_REPORT, { ...payload }, { ignore: true });
export const generateBookAllFile = ({ courseId, bookId, mode }) =>
  httpClient.get(`${apis.GET_GENERATE_BOOK_ALL_FILE}/${courseId}/${bookId}`, {
    params: { mode },
    timeout: 300000,
  });
export const getQaBulletTags = (payload) => httpClient.get(apis.getQaBulletTags(payload));
export const getQaBulletListReferal = (payload) =>
  httpClient.get(apis.getQaBulletListReferal(payload));

// im team announcement
export const getIMTeamAnnouncementByTeamId = (teamId) =>
  httpClient.get(apis.GET_IM_TEAM_ANNOUNCEMENT + `/${teamId}`);

export const getVersion = () => httpClient.get(`${apis.GET_VERSION}`);
